module.exports = __webpack_public_path__ + "media/images/partner/supporter/lokalsupport-9722a853fe5ca1f5e3dd10f3a40e39d4.png";